import gql from 'graphql-tag';
import { ShareTargetFragment } from '../fragments/coreFragments';

export const FolderFeedQuery = gql`
  query getFolderFeed($nodeId: String!, $first: Int!, $cursor: String!, $includeGroups: Boolean!) {
    nodeById(id: $nodeId) {
      ... on Folder {
        id
        title
        url
        modified
        created
        integrationType
        category
        children(first: $first, cursor: $cursor) {
          nodes {
            ... on Node {
              id
              title
              baseUrl
              url
              modified
              created
              category
              isIntegrationConnected
              integrationType
              owners {
                id
                name
                email
                avatarUrl
              }
              # ...shareTargetResults
              accessorInfo(includeGroups: $includeGroups) {
                accessors {
                  ... on Group {
                    id
                    emoji
                    groupName: name
                  }
                  ... on Person {
                    id
                    name
                    email
                    avatarUrl
                  }
                }
                pageInfo {
                  endCursor
                  hasNextPage
                  total
                }
              }
              ...shareTargetResults
              sharingEnabled
              __typename
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          __typename
        }
      }
    }
  }
  ${ShareTargetFragment}
`;
